export class Property {
    constructor(public id: number,
                public title: string, 
                public description: string,
                public area_In_Sq_Ft : string,
                public property_Type: any,
                public category: string,
                public propertyStatus: string[], 
                public property_Status: string, 
                public property_Image : Gallery[],
                public price : string,
                public city: string,
                public zipCode: string[],
                public neighborhood: string[],
                public street: string[],
                public location: Location,
                public formattedAddress: string,
                public features: string[],
                public featured: boolean,
                public priceDollar: Price,
                public priceEuro: Price,
                public bedrooms: number,
                public bathrooms: number,
                public buildingSize: number,
                public apn:number,
                public elevators: string,
                public sprinklers: string,
                public construction: string,
                public parking: string,
                public secondaryType: string,
                public secondary_type: string,
                public garages: number,
                public area: Area,
                public yearBuilt: number,
                public ratingsCount: number,
                public ratingsValue: number,
                public additionalFeatures: AdditionalFeature[],
                public highlights: Highlights[],
                public gallery: Gallery[],
                public key_documents:string[],
                public plans: Plan[],
                public videos: Video[],
                public published: string,
                public lastUpdate: string,
                public views: number){ }
}

// export class Property {
//     public id: number;
//     public title: string; 
//     public desc: string;
//     public propertyType: string;
//     public propertyStatus: string[];
//     public city: string;
//     public zipCode: string;
//     public neighborhood: string[];
//     public street: string[];
//     public location: Location;
//     public formattedAddress: string;
//     public features: string[];
//     public featured: boolean;
//     public priceDollar: Price;
//     public priceEuro: Price;
//     public bedrooms: number;
//     public bathrooms: number;
//     public garages: number;
//     public area: Area;
//     public yearBuilt: number;
//     public ratingsCount: number;
//     public ratingsValue: number;
//     public additionalFeatures: AdditionalFeature[];
//     public gallery: Gallery[];
//     public plans: Plan[];
//     public videos: Video[];
//     public published: string;
//     public lastUpdate: string;
//     public views: number
// }


export class Area {
    constructor(public id: number, 
                public value: number,
                public unit: string){ }
}
export class Users {
    constructor(public id: number,
        public name: string){ }

}
export class CreditCard {
    constructor(public name: string,
        public number: number){ }

}

export class AdditionalFeature {
    constructor(public id: number, 
                public name: string,
                public value: string){ }
}
export class Highlights {
    constructor(public id: number, 
                public highlightsName: string,
                public highlightsValue: string){ }
}

export class Location {
    constructor(public id: number, 
                public lat: number,
                public lng: number){ }
}

export class Country {
    constructor(public name: string,
                public dial_code: string,
                public code: string){ }
}

export class Price {
    public sale: number;
    public rent: number;
}


export class Gallery {
    constructor(public id: number, 
                public small: string,
                public medium: string,
                public big: string){ }
}
export class Documents {
    constructor(public url: string,
                public name: string, 
                public type: string){ }
}

export class Plan {
    constructor(public id: number, 
                public name: string,
                public desc: string,
                public area: Area,
                public rooms: number,
                public baths: number,
                public image: string){ }
}

export class Video {
    constructor(public id: number, 
                public name: string,
                public link: string){ }
}

export class Pagination {
    constructor(public page: number,
                public perPage: number,
                public prePage: number,
                public nextPage: number,
                public total: number,
                public totalPages: number){ }
}
export class subscriber {
    constructor( public name: string,
    public image: string,
    public planName: string,
    public planType:string,
    public planStatus: string,
    public createdOn: string,
    public earning: number,
    public accountStatus: string){ }
}
export class user {
    constructor( public firstName: string,
    public lastName: string,
    public email: string,
    public zipCode:string,
    public country: string,
    public createdOn: string,
    public phone: string){ }
}

export class plans {
    constructor( public planName: string,
    public price: number,
    public validity: string,
){ }
}

